function sliderTextMedia() {
    const swiperContainer = document.querySelector('.text_media_swiper-js');

    const swiper = new Swiper(swiperContainer, {
        loop: true,
        autoHeight: true,
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
}

$(function() {
    sliderTextMedia();
});